import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Checkbox,
  DatePicker,
  Input,
  InputNumber,
  message,
  Radio,
  Select,
  Space,
  Tag,
} from "antd";
import { BackIcon, UploadIcon } from "../../../../asset";
import { t } from "i18next";
import style from "./vehiclePage.module.css";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import { useNavigate, useLocation } from "react-router";
import { ROUTES } from "../../../../constant/routeConstant";
import TextArea from "antd/es/input/TextArea";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import { useVehicle } from "./VehiclePage.hooks";
import SuccessModal from "../../../../component/modal/SuccessModal";
import ModalConfirmLeave from "../../../../component/modal/ModalConfirmLeave";
import Dragger from "../../../../component/dragger/Dragger";
import SelectSearch from "../../../../component/input/SelectSearch";
import { InformationIcon } from "../../../../asset/icons";

export default function VehicleAdd() {
  const _ = require("lodash");

  const { state } = useLocation();

  const {
    depotId,
    ownership,
    ownerName,
    vehicleType,
    skillSet,
    temperatureCategory,
    vehicleBrand,
    vehicleModel,
    vehicleNo,
    vehicleNoExpDate,
    vehicleWeight,
    chassisNo,
    engineNo,
    manufacturerYear,
    pucNo,
    insuranceNo,
    accidentHistory,
    minOrderUnit,
    maxOrderUnit,
    minOrderWeight,
    maxOrderWeight,
    minOrderVolume,
    maxOrderVolume,
    fixedCost,
    variableCost,
    transporterTimeCost,
    waitingTimeCost,
    loadingTime,
    additionalProofValues,
    onChange,
    setVehicleNumberImage,
    setVehiclePucImage,
    setVehicleInsuranceImage,
    vehicleNumberImage,
    vehiclePucImage,
    vehicleInsuranceImage,
    skillsetList,
    plate1,
    plate2,
    plate3,
    temperatureCategoryList,
    setTemperatureCategory,
    doPostVehicle,
    successModalOpen,
    navigate,
    skillsetError,
    temperatureCategoryError,
    plateError,
    plateExpError,
    vehicleWeightError,
    minOrderUnitError,
    maxOrderUnitError,
    minOrderWeightError,
    maxOrderWeightError,
    minOrderVolumeError,
    maxOrderVolumeError,
    minMoreThanMaxOrderUnitError,
    maxLessThanMinOrderUnitError,
    minMoreThanMaxOrderWeightError,
    maxLessThanMinOrderWeightError,
    minMoreThanMaxOrderVolumeError,
    maxLessThanMinOrderVolumeError,
    fixedCostError,
    ownerNameError,
    setSkillsetError,
    setTemperatureCategoryError,
    setPlateError,
    setPlateExpError,
    setVehicleWeightError,
    setMinOrderUnitError,
    setMaxOrderUnitError,
    setMinOrderWeightError,
    setMaxOrderWeightError,
    setMinOrderVolumeError,
    setMaxOrderVolumeError,
    setMinMoreThanMaxOrderUnitError,
    setMaxLessThanMinOrderUnitError,
    setMinMoreThanMaxOrderWeightError,
    setMaxLessThanMinOrderWeightError,
    setMinMoreThanMaxOrderVolumeError,
    setMaxLessThanMinOrderVolumeError,
    setFixedCostError,
    setOwnerNameError,
    showConfirm,
    setShowConfirm,
    doGetListSkillset,
    setMinOrderWeight,
    selectedOptions,
    setSelectedOptions,
    selectedSkillsetId,
    setSelectedSkillsetId,
    checkIsChanged,
    doGetListVehicleAdditionalProofs,
    additionalProofList,
    isLoaded,
    additionalProofOnChange,
    combinedAdditionalProof,
    doGetMaxOrderUnit,
    maxOrder,
    parameterError,
    minOrderUnitIsBigger,
    minOrderWeightIsBigger,
    minOrderVolumeIsBigger,
    onScroll,
    skillsetKeyword,
    onSearchDDS,
    temperatureCategoryKeyword,
  } = useVehicle();

  useEffect(() => {
    doGetListSkillset(1, skillsetKeyword, "list", state.depot_id);
    doGetMaxOrderUnit();
    doGetListVehicleAdditionalProofs();
  }, []);

  const [isInfoOpened, setIsInfoOpened] = useState(false);

  const handleChange = (value) => {
    setSelectedSkillsetId([value]);
    onChange("skillset", selectedOptions);
  };

  const handleSubmit = () => {
    const formData = new FormData();
    if (
      ownership !== "" &&
      skillSet !== "" &&
      temperatureCategory !== "" &&
      vehicleNo.length === 3 &&
      minOrderUnit !== "" &&
      maxOrderUnit !== 0 &&
      minOrderWeight !== "" &&
      maxOrderWeight !== 0 &&
      minOrderVolume !== "" &&
      maxOrderVolume !== 0 &&
      fixedCost !== "" &&
      vehicleNoExpDate !== "" &&
      vehicleWeight !== "" &&
      minOrderUnit <= maxOrderUnit &&
      minOrderWeight <= maxOrderWeight &&
      minOrderVolume <= maxOrderVolume
    ) {
      if (combinedAdditionalProof.length === 0) {
        const content = {
          depot_id: state.depot_id,
          ownership: ownership,
          owner_name: ownerName,
          vehicle_type: vehicleType,
          skill_set: {
            skill_set_id: selectedSkillsetId,
          },
          temperature_category_id: temperatureCategory,
          vehicle_brand: vehicleBrand,
          vehicle_model: vehicleModel,
          vehicle_no: vehicleNo.join("-"),
          vehicle_no_exp_date: vehicleNoExpDate,
          vehicle_weight: vehicleWeight,
          chassis_no: _.toString(chassisNo),
          engine_no: engineNo,
          manufacture_year: manufacturerYear,
          puc_no: _.toString(pucNo),
          insurance_no: _.toString(insuranceNo),
          accident_history: accidentHistory,
          min_order_unit: minOrderUnit,
          max_order_unit: maxOrderUnit,
          min_order_weight: minOrderWeight,
          max_order_weight: maxOrderWeight,
          min_order_volume: minOrderVolume,
          max_order_volume: maxOrderVolume,
          fixed_cost: fixedCost,
          variable_cost: variableCost,
          transporter_time_cost: transporterTimeCost,
          waiting_time_cost: waitingTimeCost,
          loading_time: loadingTime,
        };
        formData.append("vehicle", JSON.stringify(content));
      } else {
        const content = {
          depot_id: state.depot_id,
          ownership: ownership,
          owner_name: ownerName,
          vehicle_type: vehicleType,
          skill_set: {
            skill_set_id: selectedSkillsetId,
          },
          temperature_category_id: temperatureCategory,
          vehicle_brand: vehicleBrand,
          vehicle_model: vehicleModel,
          vehicle_no: vehicleNo.join("-"),
          vehicle_no_exp_date: vehicleNoExpDate,
          vehicle_weight: vehicleWeight,
          chassis_no: _.toString(chassisNo),
          engine_no: engineNo,
          manufacture_year: manufacturerYear,
          puc_no: _.toString(pucNo),
          insurance_no: _.toString(insuranceNo),
          accident_history: accidentHistory,
          min_order_unit: minOrderUnit,
          max_order_unit: maxOrderUnit,
          min_order_weight: minOrderWeight,
          max_order_weight: maxOrderWeight,
          min_order_volume: minOrderVolume,
          max_order_volume: maxOrderVolume,
          fixed_cost: fixedCost,
          variable_cost: variableCost,
          transporter_time_cost: transporterTimeCost,
          waiting_time_cost: waitingTimeCost,
          loading_time: loadingTime,
          additional_proofs_values: combinedAdditionalProof,
        };
        formData.append("vehicle", JSON.stringify(content));
      }

      if (vehicleNumberImage && vehicleNumberImage !== null) {
        formData.append(
          "vehicle_no_photo",
          vehicleNumberImage[0]?.originFileObj
        );
      }
      if (vehiclePucImage && vehiclePucImage !== null) {
        formData.append("vehicle_puc_photo", vehiclePucImage[0]?.originFileObj);
      }
      if (vehicleInsuranceImage && vehicleInsuranceImage !== null) {
        formData.append(
          "vehicle_insurance_photo",
          vehicleInsuranceImage[0]?.originFileObj
        );
      }
      
      doPostVehicle(formData);
    } else {
      if (skillSet === "") {
        setSkillsetError(true);
      }
      if (temperatureCategory === "") {
        setTemperatureCategoryError(true);
      }
      if (vehicleNo.length !== 3) {
        setPlateError(true);
      }
      if (minOrderUnit ==="") {
        setMinOrderUnitError(true);
      }
      if (maxOrderUnit === 0) {
        setMaxOrderUnitError(true);
      }
      if (minOrderUnit > maxOrderUnit) {
        setMinMoreThanMaxOrderUnitError(true);
        setMaxLessThanMinOrderUnitError(true);
      }
      if (minOrderWeight ==="") {
        setMinOrderWeightError(true);
      }
      if (maxOrderWeight === 0) {
        setMaxOrderWeightError(true);
      }
      if (minOrderWeight > maxOrderWeight) {
        setMinMoreThanMaxOrderWeightError(true);
        setMaxLessThanMinOrderWeightError(true);
      }
      if (minOrderVolume === "") {
        setMinOrderVolumeError(true);
      }
      if (maxOrderVolume === 0) {
        setMaxOrderVolumeError(true);
      }
      if (minOrderVolume > maxOrderVolume) {
        setMinMoreThanMaxOrderVolumeError(true);
        setMaxLessThanMinOrderVolumeError(true);
      }
      if (fixedCost === "") {
        setFixedCostError(true);
      }
      if (vehicleNoExpDate === "") {
        setPlateExpError(true);
      }
      if (vehicleWeight === "") {
        setVehicleWeightError(true);
      }
    }
  };

  return isLoaded ? (
    <div className="p-[24px] flex flex-col gap-[24px]">
      <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={ROUTES.VEHICLE.LIST}
      />

      <SuccessModal
        isOpen={successModalOpen}
        onOk={() => navigate(ROUTES.VEHICLE.LIST)}
        closable={false}
        width={280}
        className={style.successModal}
        okText="Go to Homepage"
        title="Well Done"
        description={
          <p>
            <strong>
              {vehicleType} - {plate1} {plate2} {plate3} has been added
            </strong>
          </p>
        }
      />

      <Breadcumbs
        jmlLevel={4}
        menuLevel1={`Master`}
        menuLevel2={`Fleet`}
        menuLevel3={`Vehicle`}
        menuLevel4={`Add Vehicle`}
      />

      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={() => checkIsChanged()}
      >
        <div className="flex items-center gap-[22px]">
          <img src={BackIcon} alt="" />
          <h1 className="text-2xl font-sans-bold" id="title">
            {t("VEHICLE_ADD:TITLE")}
          </h1>
        </div>
      </div>

      <div
        className={
          style.tabsContainer +
          " bg-[#FFFFFF] border-[1px] border-[#DDDDDD] px-[30px] py-[24px] rounded-[10px]"
        }
      >
        <div className="flex flex-row gap-[200px]">
          <div className="flex flex-col gap-[16px]">
            <h3 className="font-roboto text-[18px] font-[500]">
              {t("VEHICLE_ADD:VEHICLE_SPECIFICATION")}
            </h3>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:VEHICLE_OWNERSHIP_FIELD")}
              </label>
              <Radio.Group
                defaultValue={t("VEHICLE_ADD:OWNED_OPTION")}
                onChange={(event) => onChange("ownership", event.target.value)}
              >
                <Radio value={t("VEHICLE_ADD:OWNED_OPTION")}>
                  {t("VEHICLE_ADD:OWNED_OPTION")}
                </Radio>
                <Radio value={t("VEHICLE_ADD:RENT_OPTION")}>
                  {t("VEHICLE_ADD:RENT_OPTION")}
                </Radio>
              </Radio.Group>
            </div>

            {ownership === "N" ? (
              <div className="w-[350px] flex flex-col gap-[8px]">
                <label className="font-[500] text-[16px] text-[#000000]">
                  {t("VEHICLE_ADD:VEHICLE_OWNER_FIELD")}{" "}
                  <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                </label>
                <Input
                  className="mt-[8px]"
                  maxLength={100}
                  placeholder={t("VEHICLE_ADD:VEHICLE_OWNER_PLACEHOLDER")}
                  onChange={(event) =>
                    onChange("vehicleOwner", event.target.value)
                  }
                />
                <p
                  className={`font-[12px] text-[#FF0000] font-roboto ${
                    ownerNameError ? `visible` : `hidden`
                  }`}
                >
                  This field is required
                </p>
              </div>
            ) : (
              ""
            )}

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:VEHICLE_TYPE_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <Input
                className="mt-[8px]"
                maxLength={20}
                placeholder={t("VEHICLE_ADD:VEHICLE_TYPE_PLACEHOLDER")}
                onChange={(event) =>
                  onChange("vehicleType", event.target.value)
                }
              />
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:SKILL_SET_FIELD")}
              </label>
              {skillsetList?.length !== 0 ? (
                <SelectSearch
                  status={skillsetError ? "error" : ""}
                  onScroll={(event) =>
                    onScroll(event, "skillsetList", state.depot_id)
                  }
                  keyword={skillsetKeyword}
                  onChange={(value) =>
                    onSearchDDS(value, "skillsetList", state.depot_id)
                  }
                  onSelect={(value) => handleChange(value)}
                  width={350}
                  options={skillsetList}
                  placeholder={"Select Skillset"}
                />
              ) : null}

              <p
                className={`font-[12px] text-[#FF0000] font-roboto ${
                  skillsetError ? `visible` : `hidden`
                }`}
              >
                This field is required
              </p>
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:TEMPERATURE_CATEGORY_ID_FIELD")}
              </label>
              {/* <SelectSearch onSelect={(value) => onChange('temperatureCategory', value)} style={style} status={temperatureCategoryError ? 'error' : null} data={temperatureOption} placeholder={"Select Temperature Category"} defaultValue={''} /> */}

              {temperatureCategoryList?.length !== 0 ? (
                <SelectSearch
                  status={temperatureCategoryError ? "error" : ""}
                  onScroll={(event) =>
                    onScroll(event, "temperatureCategoryList", state.depot_id)
                  }
                  keyword={temperatureCategoryKeyword}
                  onChange={(value) =>
                    onSearchDDS(
                      value,
                      "temperatureCategoryList",
                      state.depot_id
                    )
                  }
                  onSelect={(value) => onChange("temperatureCategory", value)}
                  width={350}
                  options={temperatureCategoryList}
                  placeholder={"Select Temperature Category"}
                />
              ) : null}

              <p
                className={`font-[12px] text-[#FF0000] font-roboto ${
                  temperatureCategoryError ? `visible` : `hidden`
                }`}
              >
                This field is required
              </p>
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:VEHICLE_BRAND_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <Input
                className="mt-[8px]"
                maxLength={30}
                placeholder={t("VEHICLE_ADD:VEHICLE_BRAND_PLACEHOLDER")}
                onChange={(event) =>
                  onChange("vehicleBrand", event.target.value)
                }
              />
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:VEHICLE_MODEL_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <Input
                className="mt-[8px]"
                maxLength={256}
                placeholder={t("VEHICLE_ADD:VEHICLE_MODEL_PLACEHOLDER")}
                onChange={(event) =>
                  onChange("vehicleModel", event.target.value)
                }
              />
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:LICENCE_PLATE_FIELD")}
              </label>
              <div className="flex gap-[8px]">
                <Input
                  className="mt-[8px] w-[47px] text-center"
                  style={
                    plateError
                      ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                      : {}
                  }
                  maxLength={1}
                  placeholder="X"
                  onChange={(event) => onChange("plate1", event.target.value)}
                />
                <InputNumber
                  controls={false}
                  type="number"
                  style={
                    plateError
                      ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                      : {}
                  }
                  className="mt-[8px] w-[78px] text-center"
                  maxLength={4}
                  placeholder="1234"
                  onChange={(event) => onChange("plate2", event)}
                />
                <Input
                  className="mt-[8px] w-[71px] text-center"
                  style={
                    plateError
                      ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                      : {}
                  }
                  maxLength={3}
                  placeholder="ABC"
                  onChange={(event) => onChange("plate3", event.target.value)}
                />
              </div>
              <p
                className={`font-[12px] text-[#FF0000] font-roboto ${
                  plateError ? `visible` : `hidden`
                }`}
              >
                This field is required
              </p>
            </div>
            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:LICENCE_PLATE_EXPIRED_FIELD")}
              </label>
              <DatePicker
                placeholder={t("VEHICLE_ADD:LICENCE_PLATE_EXPIRED_PLACEHOLDER")}
                style={
                  plateExpError
                    ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                    : {}
                }
                format={`DD MMMM YYYY`}
                onChange={(date, dateString) =>
                  onChange("licencePlateExpired", dateString)
                }
              />
              <p
                className={`font-[12px] text-[#FF0000] font-roboto ${
                  plateExpError ? `visible` : `hidden`
                }`}
              >
                This field is required
              </p>
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:VEHICLE_WEIGHT_FIELD")}
              </label>
              <InputNumber
                min="0"
                controls={false}
                className="w-[350px]"
                style={
                  vehicleWeightError
                    ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                    : {}
                }
                placeholder="5.000.000"
                addonAfter={<div className="text-[#818181]">Kg</div>}
                onChange={(event) => onChange("vehicleWeight", event)}
              />
              <p
                className={`font-[12px] text-[#FF0000] font-roboto ${
                  vehicleWeightError ? `visible` : `hidden`
                }`}
              >
                This field is required
              </p>
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:VEHICLE_CHASIS_NUMBER_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <Input
                className="mt-[8px] w-[350px]"
                maxLength={100}
                controls={false}
                placeholder={t("VEHICLE_ADD:VEHICLE_CHASIS_NUMBER_PLACEHOLDER")}
                onChange={(event) =>
                  onChange("vehicleChassisNo", event.target.value)
                }
              />
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:VEHICLE_ENGINE_NUMBER_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <Input
                className="mt-[8px] w-[350px]"
                maxLength={30}
                controls={false}
                placeholder={t("VEHICLE_ADD:VEHICLE_ENGINE_NUMBER_PLACEHOLDER")}
                onChange={(event) =>
                  onChange("vehicleEngineNo", event.target.value)
                }
              />
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:MANUFACTURE_YEAR_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <DatePicker
                placeholder={t("VEHICLE_ADD:MANUFACTURE_YEAR_PLACEHOLDER")}
                picker="year"
                onChange={(date, dateString) =>
                  onChange("manufactureYear", dateString)
                }
              />
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:PUC_NUMBER_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <Input
                className="mt-[8px] w-[350px]"
                maxLength={20}
                controls={false}
                placeholder={t("VEHICLE_ADD:PUC_NUMBER_PLACEHOLDER")}
                onChange={(event) => onChange("pucNo", event.target.value)}
              />
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:VEHICLE_INSURANCE_NUMBER_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <Input
                className="mt-[8px] w-[350px]"
                maxLength={20}
                controls={false}
                placeholder={t(
                  "VEHICLE_ADD:VEHICLE_INSURANCE_NUMBER_PLACEHOLDER"
                )}
                onChange={(event) =>
                  onChange("vehicleInsuranceNo", event.target.value)
                }
              />
            </div>

            {/* To Do Adjustment */}

            {/* <div className="w-[350px] flex flex-col gap-[8px]">
                                <label className='font-[500] text-[16px] text-[#000000]'>{t("Total Range Distance")}  </label>
                                <InputNumber disabled min="0" controls={false} className='w-[350px]' placeholder='0' addonAfter={<div className='text-[#818181]'>Km</div>} onChange={(event) => onChange('loadingTime', event.target.value)} />
                            </div> */}

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:ACCIDENT_HISTORY_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <TextArea
                style={{ height: 94, resize: "none" }}
                maxLength={256}
                className="mt-[8px]"
                placeholder={t("VEHICLE_ADD:ACCIDENT_HISTORY_PLACEHOLDER")}
                onChange={(event) =>
                  onChange("accidentHistory", event.target.value)
                }
              />
            </div>

            <div className="w-[500px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:LICENCE_PLATE_PHOTO_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <Dragger
                selectedFileList={vehicleNumberImage}
                setSelectedFileList={setVehicleNumberImage}
              />
            </div>

            <div className="w-[500px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:PUC_NUMBER_PHOTO_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <Dragger
                selectedFileList={vehiclePucImage}
                setSelectedFileList={setVehiclePucImage}
              />
            </div>

            <div className="w-[500px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:VEHICLE_INSURANCE_NUMBER_PHOTO")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <Dragger
                selectedFileList={vehicleInsuranceImage}
                setSelectedFileList={setVehicleInsuranceImage}
              />
            </div>
          </div>
          <div className="flex flex-col gap-[16px]">
            <div className="flex gap-[6px] items-center">
              <h3 className="font-roboto text-[18px] font-[500]">
                {"Vehicle Specification"}
              </h3>
              <div
                className="cursor-pointer"
                onMouseEnter={() => setIsInfoOpened(true)}
                onMouseLeave={() => setIsInfoOpened(false)}
              >
                <InformationIcon />
              </div>
              <div
                className={`relative z-20 animate-popup delay-75 ${
                  isInfoOpened ? `visible` : `hidden`
                }`}
              >
                <div className="w-[300px] h-auto rounded-[8px] bg-[#ECEDEE] shadow absolute top-[-10px] p-[8px]">
                  <p className="font-[500] text-[18px] text-[#424242]">
                    The values of the order unit, order weight, and order volume
                    depend on the parameter settings.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex gap-[16px]">
              <div className="w-[242px]">
                <label className="font-[500] text-[16px] text-[#000000]">
                  {t("VEHICLE_ADD:MIN_ORDER_UNIT_FIELD")}
                </label>
                <InputNumber
                  min={0}
                  controls={false}
                  style={
                    minOrderUnitError || minMoreThanMaxOrderUnitError
                      ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                      : {}
                  }
                  className="w-[242px]"
                  addonAfter={<div className="text-[#818181]">PCS</div>}
                  placeholder="0"
                  onChange={(event) => onChange("minOrderUnit", event)}
                />
                <p
                  className={`font-[12px] text-[#FF0000] font-roboto ${
                    minOrderUnitError ? `visible` : `hidden`
                  }`}
                >
                  This field is required
                </p>
                <p
                  className={`font-[12px] text-[#FF0000] font-roboto ${
                    minMoreThanMaxOrderUnitError ? `visible` : `hidden`
                  }`}
                >
                  Must be lower than the maximum value
                </p>
              </div>
              <div className="w-[242px]">
                <label className="font-[500] text-[16px] text-[#000000]">
                  {t("VEHICLE_ADD:MAX_ORDER_UNIT_FIELD")}
                </label>
                <InputNumber
                  min={0}
                  controls={false}
                  className="w-[242px]"
                  style={
                    maxOrderUnitError ||
                    parameterError ||
                    maxLessThanMinOrderUnitError
                      ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                      : {}
                  }
                  addonAfter={<div className="text-[#818181]">PCS</div>}
                  placeholder="0"
                  onChange={(event) => onChange("maxOrderUnit", event)}
                />
                <p
                  className={`font-[12px] text-[#FF0000] font-roboto ${
                    maxOrderUnitError ? `visible` : `hidden`
                  }`}
                >
                  This field is required
                </p>
                {/* <p className={`font-[12px] text-[#FF0000] font-roboto ${parameterError ? `visible` : `hidden`}`}>Max {maxOrder} PCS</p> */}
                <p
                  className={`font-[12px] text-[#FF0000] font-roboto ${
                    maxLessThanMinOrderUnitError ? `visible` : `hidden`
                  }`}
                >
                  Must be higher than the minimum value
                </p>
                {/* <p className={`font-[12px] text-[#818181] font-roboto ${!maxLessThanMinOrderUnitError && !maxOrderUnitError && !parameterError ? `visible` : `hidden`}`}>Max {maxOrder} PCS</p> */}
              </div>
            </div>

            <div className="flex gap-[16px]">
              <div className="w-[242px]">
                <label className="font-[500] text-[16px] text-[#000000]">
                  {t("VEHICLE_ADD:MIN_ORDER_WEIGHT_FIELD")}
                </label>
                <InputNumber
                  min="0"
                  controls={false}
                  className="w-[242px]"
                  placeholder="0"
                  style={
                    minOrderWeightError || minMoreThanMaxOrderWeightError
                      ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                      : {}
                  }
                  addonAfter={<div className="text-[#818181]">Kg</div>}
                  onChange={(event) => onChange("minOrderWeight", event)}
                />
                <p
                  className={`font-[12px] text-[#FF0000] font-roboto ${
                    minOrderWeightError ? `visible` : `hidden`
                  }`}
                >
                  This field is required
                </p>
                <p
                  className={`font-[12px] text-[#FF0000] font-roboto ${
                    minMoreThanMaxOrderWeightError ? `visible` : `hidden`
                  }`}
                >
                  Must be lower than the maximum value
                </p>
              </div>
              <div className="w-[242px]">
                <label className="font-[500] text-[16px] text-[#000000]">
                  {t("VEHICLE_ADD:MAX_ORDER_WEIGHT_FIELD")}
                </label>
                <InputNumber
                  min="0"
                  controls={false}
                  className="w-[242px]"
                  placeholder="0"
                  style={
                    maxOrderWeightError || maxLessThanMinOrderWeightError
                      ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                      : {}
                  }
                  addonAfter={<div className="text-[#818181]">Kg</div>}
                  onChange={(event) => onChange("maxOrderWeight", event)}
                />
                <p
                  className={`font-[12px] text-[#FF0000] font-roboto ${
                    maxOrderWeightError ? `visible` : `hidden`
                  }`}
                >
                  This field is required
                </p>
                <p
                  className={`font-[12px] text-[#FF0000] font-roboto ${
                    maxLessThanMinOrderWeightError ? `visible` : `hidden`
                  }`}
                >
                  Must be higher than the minimum value
                </p>
              </div>
            </div>

            <div className="flex gap-[16px]">
              <div className="w-[242px]">
                <label className="font-[500] text-[16px] text-[#000000]">
                  {t("VEHICLE_ADD:MIN_ORDER_VOLUME_FIELD")}
                </label>
                <InputNumber
                  min="0"
                  controls={false}
                  className="w-[242px]"
                  placeholder="0"
                  style={
                    minOrderVolumeError || minMoreThanMaxOrderVolumeError
                      ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                      : {}
                  }
                  addonAfter={<div className="text-[#818181]">m³</div>}
                  onChange={(event) => onChange("minOrderVolume", event)}
                />
                <p
                  className={`font-[12px] text-[#FF0000] font-roboto ${
                    minOrderVolumeError ? `visible` : `hidden`
                  }`}
                >
                  This field is required
                </p>
                <p
                  className={`font-[12px] text-[#FF0000] font-roboto ${
                    minMoreThanMaxOrderVolumeError ? `visible` : `hidden`
                  }`}
                >
                  Must be lower than the maximum value
                </p>
              </div>
              <div className="w-[242px]">
                <label className="font-[500] text-[16px] text-[#000000]">
                  {t("VEHICLE_ADD:MAX_ORDER_VOLUME_FIELD")}
                </label>
                <InputNumber
                  min="0"
                  controls={false}
                  className="w-[242px]"
                  placeholder="0"
                  style={
                    maxOrderVolumeError || maxLessThanMinOrderVolumeError
                      ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                      : {}
                  }
                  addonAfter={<div className="text-[#818181]">m³</div>}
                  onChange={(event) => onChange("maxOrderVolume", event)}
                />
                <p
                  className={`font-[12px] text-[#FF0000] font-roboto ${
                    maxOrderVolumeError ? `visible` : `hidden`
                  }`}
                >
                  This field is required
                </p>
                <p
                  className={`font-[12px] text-[#FF0000] font-roboto ${
                    maxLessThanMinOrderVolumeError ? `visible` : `hidden`
                  }`}
                >
                  Must be higher than the minimum value
                </p>
              </div>
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:FIX_COST_FIELD")}
              </label>
              <InputNumber
                min="0"
                controls={false}
                className="w-[350px]"
                placeholder={t("VEHICLE_ADD:FIX_COST_PLACEHOLDER")}
                style={
                  fixedCostError
                    ? { border: "#CF0000 solid 1px", borderRadius: "6px" }
                    : {}
                }
                addonBefore={<div className="text-[#818181]">IDR</div>}
                onChange={(event) => onChange("fixCost", event)}
              />
              <p
                className={`font-[12px] text-[#FF0000] font-roboto ${
                  fixedCostError ? `visible` : `hidden`
                }`}
              >
                This field is required
              </p>
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:VARIABLE_COST_PER_KM_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <InputNumber
                min="0"
                controls={false}
                className="w-[350px]"
                placeholder={t("VEHICLE_ADD:VARIABLE_COST_PER_KM_PLACEHOLDER")}
                addonBefore={<div className="text-[#818181]">IDR</div>}
                onChange={(event) => onChange("variableCost", event)}
              />
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:TRANSPORTER_TIME_COST_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <InputNumber
                min="0"
                controls={false}
                className="w-[350px]"
                placeholder={t("VEHICLE_ADD:TRANSPORTER_TIME_COST_PLACEHOLDER")}
                addonBefore={<div className="text-[#818181]">IDR</div>}
                onChange={(event) => onChange("transporterTimeCost", event)}
              />
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:WAITING_TIME_COST_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <InputNumber
                min="0"
                controls={false}
                className="w-[350px]"
                placeholder={t("VEHICLE_ADD:WAITING_TIME_COST_PLACEHOLDER")}
                addonBefore={<div className="text-[#818181]">IDR</div>}
                onChange={(event) => onChange("waitingTimeCost", event)}
              />
            </div>

            <div className="w-[350px] flex flex-col gap-[8px]">
              <label className="font-[500] text-[16px] text-[#000000]">
                {t("VEHICLE_ADD:LOADING_TIME_FIELD")}{" "}
                <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
              </label>
              <InputNumber
                min="0"
                controls={false}
                className="w-[350px]"
                placeholder="0"
                addonAfter={<div className="text-[#818181]">Min</div>}
                onChange={(event) => onChange("loadingTime", event)}
              />
            </div>

            {additionalProofList?.map((item) => {
              return (
                <div className="w-[350px] flex flex-col gap-[8px]">
                  <label className="font-[500] text-[16px] text-[#000000]">
                    {item.additional_name}{" "}
                    <i>{t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                  </label>
                  <Input
                    className="mt-[8px] w-[350px]"
                    placeholder={item.description}
                    onChange={(event) =>
                      additionalProofOnChange(item.id, event.target.value)
                    }
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="flex flex-row-reverse gap-[16px]">
        <PrimaryButton
          text={t("VEHICLE_ADD:ADD")}
          action={() => handleSubmit()}
        />
        <SecondaryButton
          text={t("VEHICLE_ADD:CANCEL")}
          action={() => checkIsChanged()}
        />
      </div>
    </div>
  ) : (
    ""
  );
}
